import i18n from 'modules/core/lib/i18n'
import { type Users } from 'modules/core/store/collections/users'

import { validateEmailForCreation } from 'modules/employees/lib/validateEmailForCreation'
import { type Employees } from 'modules/employees/store/collections/employees'

type Props = {
  email: string
  employees: Employees
  users: Users
}

const validateEmail = ({ email, employees, users }: Props) => {
  const { valid, errorString } = validateEmailForCreation(email, employees, users)

  return {
    isValid: valid,
    message: errorString ?? i18n.t('importer_process.edition_step.validators.email'),
  }
}

export default validateEmail
